// extracted by mini-css-extract-plugin
export default {"container":"onfido-sdk-ui-Pannable-container"};